export function ToolDetail() {
  return <div>Tool Detail - Coming Soon</div>;
}
